/* ==========================================================================
   Searcher > Client > Prototype
   ========================================================================== */

/* Modules */
const { Store } = require('@bluekiri/alexandria/helpers/state');

const { reducer } = require('./store/reducer');
const { actions, types } = require('./store/actions');

const { initCalendar } = require('./calendar');
const { initAccommodation } = require('./accommodation');
const { initVehicle } = require('./vehicle');
const { initOrigin } = require('./origin');
const { initDestination } = require('./destination');
const { initSubmit } = require('./submit');

const { errorManager } = require('./validations');
const { hasPanel } = require('./helpers');

/* Prototype */
const prototype = {
    /* Setup store */
    setupStore() {
        if (this.store) return this;
        this.store = new Store({
            data: reducer
        });

        return this;
    },

    /* Setup actions */
    setupActions() {
        if (this.actions) return this;

        this.actions = {
            destroy: () => this.store.dispatch(actions.destroy()),
            setData: data => this.store.dispatch(actions.setData(data)),
            changeData: data => this.store.dispatch(actions.changeData(data)),
            setVehicle: data => this.store.dispatch(actions.setVehicle(data)),
            changeVehicle: data => this.store.dispatch(actions.changeVehicle(data)),
            setError: error => this.store.dispatch(actions.setError(error)),
            removeError: () => this.store.dispatch(actions.removeError()),
            openPanel: panel => this.store.dispatch(actions.openPanel(panel)),
            closePanel: panel => this.store.dispatch(actions.closePanel(panel)),
            lock: () => this.store.dispatch(actions.lock()),
            unlock: () => this.store.dispatch(actions.unlock())
        };

        return this;
    },
    /* Setup reactions */
    setupReactions() {
        if (this.reactions) return this;

        this.reactions = {
            destroy: this.store.subscribe((state, action) => {
                if (action.type !== types.DESTROY) return;

                /* Destroy componentes */
                if (this.origin) this.origin.actions.destroy();
                if (this.destination) this.destination.actions.destroy();
                if (this.calendarInput) this.calendarInput.actions.destroy();
                if (this.accommodationInput) this.accommodationInput.actions.destroy();
                if (this.vehicleInput) this.vehicleInput.actions.destroy();

                /* Unsubscribe */
                this.unsubscribe();
                [...Object.keys(this.reactions)].forEach(key => this.reactions[key].unsubscribe());

                /* Clean DOM */
                this.element.parentNode.removeChild(this.element);

                /* Clean reference */
                [...Object.keys(this)].forEach(key => delete this[key]);
            }),

            openPanel: this.store.subscribe((state, action) => {
                if (action.type !== types.OPEN_PANEL) return;

                this.actions.lock();
            }),
            closePanel: this.store.subscribe((state, action) => {
                if (action.type !== types.CLOSE_PANEL) return;

                if (!hasPanel(this)) this.actions.unlock();
            }),
            setError: this.store.subscribe((state, action) => {
                if (action.type !== types.SET_ERROR) return;

                errorManager(this);
                this.actions.lock();
            }),
            removeError: this.store.subscribe((state, action) => {
                if (action.type !== types.REMOVE_ERROR) return;

                this.actions.unlock();
            }),
            lock: this.store.subscribe((state, action) => {
                if (action.type !== types.LOCK) return;

                /* Data store */
                const { locked } = this.store.select('data');

                if (this.submit && locked) this.submit.actions.disable();
            }),
            unlock: this.store.subscribe((state, action) => {
                if (action.type !== types.UNLOCK) return;

                /* Data store */
                const { locked, hasError, hasPanel: searcherHasPanel } = this.store.select('data');

                if (this.submit && !locked && !hasError && !searcherHasPanel) this.submit.actions.enable();
            })
        };

        return this;
    },
    /* Subscribe */
    subscribe() {
        if (this.subscriptions) this.unsubscribe();

        this.subscriptions = {};

        return this;
    },
    /* Unsubscribe */
    unsubscribe() {
        if (!this.subscriptions) return this;

        [...Object.keys(this.subscriptions)].forEach(key => this.subscriptions[key].unsubscribe());

        return this;
    },
    /* Start */
    start() {
        if (!this.config.start) return this;

        const { destinationPort, originPort } = this.config || {};

        /* Sync store */
        if (originPort) this.actions.setData({ origin: originPort });
        if (destinationPort) this.actions.setData({ destination: destinationPort });

        return this;
    },
    /* Setup events */
    setupEvents() {
        if (!this.config.events) return this;

        this.events = {};

        return this;
    },
    /* Init */
    init() {
        if (!this.config.init) return this;

        /* Setup store */
        this.setupStore();

        /* Setup actions */
        this.setupActions();

        /* Setup reactions */
        this.setupReactions();

        /* Subscribe */
        this.subscribe();

        /* Events */
        this.setupEvents();

        /* Init components */
        initDestination(this);
        initOrigin(this);
        initCalendar(this);
        initAccommodation(this);
        initVehicle(this);
        initSubmit(this);

        /* Start */
        this.start();

        return this;
    }
};

/* Exports */
module.exports = prototype;
